module.exports = __webpack_public_path__ + "img/house.2b65c294.svg";